import AssignmentLateIcon from "@material-ui/icons/AssignmentLate";

import ApproveCancellationOrderRequest from "views/OrderCancellation/ApproveCancellationOrderRequest.js";
import CancellationApprovedOrderList from "views/OrderCancellation/CancellationApprovedOrderList.js";
import CancellationRejectedOrderList from "views/OrderCancellation/CancellationRejectedOrderList.js";
import CancellationRequestedOrderList from "views/OrderCancellation/CancellationRequestedOrderList.js";
import OrderCancellationDetail from "views/OrderCancellation/OrderCancellationDetail.js";
import RejectCancellationOrderRequest from "views/OrderCancellation/RejectCancellationOrderRequest.js";
import { token } from "functions/Helper";

const orderCancellation = () => {
  let views = [];

  if (token["order.orders.read"] === "allowed" || token.is_admin === "True")
    views = views.concat([
      {
        path: "/OrderCancellations/Requested",
        name: "Requested",
        mini: "RE",
        component: CancellationRequestedOrderList,
        layout: "/admin"
      },
      {
        path: "/OrderCancellations/Approved",
        name: "Approved",
        mini: "AP",
        component: CancellationApprovedOrderList,
        layout: "/admin"
      },
      {
        path: "/OrderCancellations/Rejected",
        name: "Rejected",
        mini: "RJ",
        component: CancellationRejectedOrderList,
        layout: "/admin"
      }
    ]);

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Order Cancellations",
        icon: AssignmentLateIcon,
        state: "orderCancellationCollapse",
        views: views
      }
    ];
  return [];
};
const orderCancellationHidden = () => {
  let views = [];
  if (token["order.orders.read"] === "allowed" || token.is_admin === "True")
    views.push({
      path: "/OrderCancellations/Detail",
      name: "Order Cancellation Detail",
      component: OrderCancellationDetail,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  if (
    token["order.orders.approve_cancellation_request"] === "allowed" ||
    token.is_admin === "True"
  )
    views = views.concat([
      {
        path: "/OrderCancellations/Approve",
        name: "Approve Cancellation",
        component: ApproveCancellationOrderRequest,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  if (
    token["order.orders.reject_cancellation_request"] === "allowed" ||
    token.is_admin === "True"
  )
    views = views.concat([
      {
        path: "/OrderCancellations/Reject",
        name: "Reject Cancellation",
        component: RejectCancellationOrderRequest,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Order Cancellation Hidden",
        state: "orderCancellationHiddenCollapse",
        hideInSidebar: true,
        views: views
      }
    ];
  return [];
};
export { orderCancellation, orderCancellationHidden };
